import AWS from 'aws-sdk';
import {Auth} from 'aws-amplify';

const submitStatus = (status, id) => {

  let S3;

  return Auth.currentCredentials()
  .then(credentials => {

    S3 = new AWS.S3(Auth.essentialCredentials(credentials));

    const params = {
      Bucket: 'weaveability-basis-utilities-storage',
      Key: `feedback/feedback-${id}.json`,
    };

    return S3.getObject(params).promise();

  })
  .then(res => {
    const feedback = JSON.parse(res.Body.toString());

    feedback.status.unshift(status);

    const params = {
      Bucket: 'weaveability-basis-utilities-storage',
      Key: `feedback/feedback-${id}.json`,
      Body: JSON.stringify(feedback)
    };

    return S3.upload(params).promise();
  })
  .catch(err => {
    console.log(err);
  });

};

export default submitStatus;


// WEBPACK FOOTER //
// ./src/components/content/feedback/utils/submitStatus.js